import React from "react";
import { useValidate } from "formvalidation/hooks";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { Utils } from "common/utils";
import OptionalTextInput from "./OptionalTextInput";

interface Props {
  validatorKey: string
  value: string
  onChange: (newTitle: string) => void
  maxLength: number
  onBlur?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  loading?: boolean
}

const MultiEmailInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  const validate = async (input: string) => {
    if (input.trim().length === 0) {
      return true;
    }

    const emails = Utils.splitEmails(input);
    const allEmailsValid = emails.every(email => Utils.isValidEmailAddress(email));

    return allEmailsValid;
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: "Email Addresses",
    value: props.value,
    validate,
    ref: semanticRef.ref
  });

  return <OptionalTextInput
    focusOnMount={props.focusOnMount}
    placeholder={props.placeholder}
    innerRef={semanticRef}
    value={props.value}
    onChange={props.onChange}
    maxLength={props.maxLength}
    onBlur={props.onBlur}
    onEnter={props.onEnter}
    onEsc={props.onEsc}
    disabled={props.disabled}
    loading={props.loading}
    hasError={validation.error.hasError}
  />
};

export default MultiEmailInput;